import React, { Component } from 'react';
import Input from '../component/Input.js';
import axios from 'axios';
import {path} from './routes.js';
import SelectBox from '../component/Select.js';
import Validation from './Validation.js'; //used for validation

export default class ResetPassword extends Component {
	constructor(props){
		super(props);
		this.getQuestion = this.getQuestion.bind(this);
		//this.getQuestionList = this.getQuestionList.bind(this);
		this.handleInput = this.handleInput.bind(this);
		this.afterSubmit = this.afterSubmit.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.state = {email:'',password:'',newPass:'',confirm:'',answer:'',question:'',questions:[],invalid:true,confirmed:false,reset:'',prompt:'',first:false};
	}

	handleInput(identity,value){ //standard method for handling user input
		const theState = {};
		theState[identity] = value;
		this.setState(theState);
	}

	getQuestionList(){ //method for retrieving security questions
		axios({
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'info',table:'question'}
		}).then((response)=>{
			let data = response.data.data;
			let questions = data.map((questions)=>{
				return questions.Question;
			});
			this.setState({question:data[0].Question,questions:questions});
		});
	}

	getQuestion(){ //method that retrieves the users security question
		axios({
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'info',table:'users',action:'question',name:this.state.email.toLowerCase(),kind:this.state.password}
		}).then((response)=>{
			let data = response.data.data;
			if(data[0].Message !== "invalid"){
				if(data[0].Question === null){
					this.getQuestionList();
				}else{
					this.setState({question:data[0].Question});
				}
				if(this.state.invalid){
					this.setState({invalid:false,prompt:''});
				}
			}
		});
	}
	// componentDidMount(){
	// 	this.getQuestionList();
	// }

	componentDidUpdate(prevProps,prevState){
		if(this.state.email.trim() !== '' && this.state.password.trim() !== '' && this.state.invalid && prevState.email === this.state.email && prevState.password===this.state.password && prevState.newPass !== this.state.newPass){ //attempt to retrieve the user's security question if they have filled out their email and password
			this.getQuestion();
		}
		if(this.state.confirm.trim() !== '' && this.state.newPass.trim() === this.state.confirm.trim() && !this.state.confirmed){ //confirm password matches new password
			this.setState({confirmed:true});
		}else if(this.state.confirm.trim() !== '' && this.state.newPass.trim() !== this.state.confirm.trim() && this.state.confirmed){ //confirm password does not match new password
			this.setState({confirmed:false});
		}
	}

	afterSubmit(message){ //method that displays error message
		if(message === "failed"){
			setTimeout(()=>{
				this.setState({password:'',newPass:'',confirm:'',answer:'',invalid:true,confirmed:false,reset:'',prompt:'The information provided is incorrect.'});
			},3000);
		}
	}

	onSubmit(){ //method for submitting information, including user's new password
		const {email,password,newPass,answer,confirmed,first,question} = this.state;
		let data;
		if(email.trim() !== '' && newPass.trim() !== '' && confirmed){ //if all fields are filled out and the user has confirmed their new password, continue
			//&& answer.trim() !== ''
			if(!this.state.first){ //if the user has logged in before and is resetting their password
				data = {endpoint:'create',table:'users',misc:'password',email:email.trim(),answer:answer.trim().toLowerCase(),status:newPass,name:password,desc:question};
			}else{ //if the user has not logged in before and is resetting their password
				data = {endpoint:'create',table:'users',misc:'password_first',email:email.trim(),answer:answer.trim().toLowerCase(),status:newPass,name:password,desc:question};
			}
			axios({
				method:'post',
				url:path,headers:{'Content-Type':'application/json'},
				data:data
			}).then((response)=>{
				let data = response.data.data;
				this.setState({reset:data.Message});
				this.afterSubmit(data.Message);
			});
		}else{ //set error message
			this.setState({prompt:'All fields are required'});
		}
	}

	render(){
		let content;
		let questioncontent;
		const inputStyles = "h2 pl3 br2 bw1 w-100 shadow-3 b--light-silver";
		const labelStyles = "fl w-100 tl pr4-ns b navy f5 mt3";
		const inputDiv = "fl w-100 tl pt2";
		const outerDiv = "mb5 pb3";
		let confirmStyle = inputStyles;
		let confirmSpan;
		if(this.state.confirm.trim() !== '' && !this.state.confirmed){ //red if new password not confirmed
			confirmStyle = "h2 pl3 br2 bw1 w-100 shadow-3 b--red";
			confirmSpan = <span className="red"> *</span>;
		}else if(this.state.confirmed){ //green if new password is confirmed
			confirmStyle = "h2 pl3 br2 bw1 w-100 shadow-3 b--green";
			confirmSpan = <span className="green"> *</span>;
		}
		let prompt;
		if(this.state.prompt !== ''){
			prompt = "*"+this.state.prompt;
		}
		if(!this.state.first){ //if user has logged in before, display their chosen security question and prompt them for the answer
			if(this.state.question !== ''){
				questioncontent = <div className={outerDiv}>
										<div className={labelStyles}>
											<label>Security Question:</label>
										</div>
										<div className="fl w-100 tl pt1">
										<p className = "f5 b">{this.state.question}</p>
											<Input identity="answer" inputStyle={inputStyles} onInput={this.handleInput}/>
										</div>
									</div>;
				// questioncontent = <div className={outerDiv}>
		// 									<div>
		// 										<div className={labelStyles}>
		// 											<label>Security Question:</label>
		// 										</div>
		// 										<div>
		// 											<SelectBox identity="question" options={this.state.questions} styles={inputStyles} onSelect={this.handleInput} />
		// 										</div>
		// 									</div>
		// 										<div className={labelStyles}>
		// 											<label>Security Answer:</label>
		// 										</div>
		// 										<div className="fl w-100 tl pt1">
		// 											<Input identity="answer" inputStyle={inputStyles} onInput={this.handleInput}/>
		// 										</div>
		// 								</div>;
			}
		}else{ //if user has not logged in before, prompt them to choose a security question and to enter an answer for it
			questioncontent = <div className={outerDiv}>
									<div>
										<div className={labelStyles}>
											<label>Security Question (choose one):</label>
										</div>
										<div>
											<SelectBox identity="question" options={this.state.questions} styles={inputStyles} onSelect={this.handleInput} />
										</div>
									</div>
										<div className={labelStyles}>
											<label>Security Answer:</label>
										</div>
										<div className="fl w-100 tl pt1">
											<Input identity="answer" inputStyle={inputStyles} onInput={this.handleInput}/>
										</div>
								</div>;
		}
		if(this.state.reset === "success"){ //display success message
			content = <div><p className="f3 b navy tc">Your password has successfully been changed!</p></div>;
		}else if(this.state.reset === "failed"){ //display error message
			content = <div><p className="f3 b navy tc">Password reset has failed. Please try again.</p></div>;
		}else{ //display input fields
			content = <div style={{minHeight:'350px'}}>
				<div>
					<h1 className="b navy f3 tc pa0 ma0">Reset Password</h1>
				</div>
				<div className={outerDiv}>
					<div className={labelStyles}>
						<label>Email: <span className="red">{prompt}</span></label>
					</div>
					<div className={inputDiv}>
						<Input identity="email" inputStyle={inputStyles} onInput={this.handleInput} val={this.state.email}/>
					</div>
				</div>

				<div className={outerDiv}>
					<div className={labelStyles}>
						<label>Password:</label>
					</div>
					<div className={inputDiv}>
						<Input identity="password" inputStyle={inputStyles} onInput={this.handleInput} type="password"/>
					</div>
				</div>

				<div className={outerDiv}>
					<div className={labelStyles}>
						<label>New Password:</label>
					</div>
					<div className={inputDiv}>
						<Input identity="newPass" inputStyle={inputStyles} onInput={this.handleInput} type="password"/>
					</div>
				</div>

				<div className={outerDiv}>
					<div className={labelStyles}>
						<label>Confirm Password: {confirmSpan}</label>
					</div>
					<div className={inputDiv}>
						<Input identity="confirm" inputStyle={confirmStyle} onInput={this.handleInput} type="password"/>
					</div>
				</div>
				{questioncontent}
				<div className="fl w-100 tc mt3 mb3">
					<button className="fc w-40-ns w-100 br3 h2 shadow-3 bg-navy white" onClick={this.onSubmit}>Submit</button>
				</div></div>;
		}
		return(
			<div style={{maxWidth:'100%',margin:'auto'}}>
				{content}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/container/ResetPassword.js